import React, { Component } from "react"
import "gsap"

export default class extends Component {
  componentDidMount() {
    const mama = this.el.querySelector("#yomama-mama")

    this.animation = TweenMax.fromTo(
      mama,
      5,
      {
        morphSVG:
          "M307.3,300c0,4-3.3,7.3-7.3,7.3s-7.3-3.3-7.3-7.3s3.3-7.3,7.3-7.3S307.3,296,307.3,300z",
        fill: "#FFF",
        stroke: "none"
      },
      {
        morphSVG: mama,
        fill: "none",
        stroke: "#FFF",
        repeat: -1,
        yoyo: true,
        ease: Power3.easeInOut
      }
    )

    this.animation.paused(!this.props.isActive)
  }

  componentWillReceiveProps(nextProps) {
    this.animation.paused(!nextProps.isActive)
  }

  render() {
    return (
      <svg ref={el => (this.el = el)} viewBox="0 0 600 600">
        <path
          d="M600 300c0 165.69-134.31 300-300 300S0 465.69 0 300 134.31 0 300 0s300 134.31 300 300"
          fill="#6A1B9A"
        />
        <path
          id="yomama-mama"
          d="M512.93 220.3c-21-30.9-52.41-53.24-88.51-62.93l-16.81-4.51c-3.03-.81-6.06-1.58-9.1-2.3-2.22-.53-3.2-3.1-1.95-5.01 2.97-4.55 4.45-9.9 4.45-15.23 0-10.12-5.32-20.23-15.95-24.98-1.81-.81-2.52-2.98-1.53-4.7 10.65-18.48-3.69-41.03-23.68-41.03-1.85 0-3.75.2-5.69.61-1.95.41-3.79-.93-4-2.91-2.45-23.17-31.91-32.74-47.51-15.43-1.33 1.48-3.62 1.48-4.95 0-16.29-18.06-47.67-6.84-47.67 18.57 0 .29 0 .58.01.86-19.54-6.95-36.84 8.62-36.84 26.01 0 4.43 1.12 8.98 3.61 13.31 1 1.73.3 3.9-1.52 4.71-10.64 4.75-15.95 14.86-15.95 24.98 0 5.93 1.83 11.86 5.48 16.71 1.43 1.89.55 4.61-1.74 5.2-.81.21-1.61.42-2.41.64l-16.81 4.51c-36.1 9.69-67.51 32.02-88.51 62.93-3.36 4.96-5.09 10.74-5.09 16.54 0 3.99.81 8 2.46 11.78L97 258.4c12.83 29.34 30.75 56.18 52.92 79.28l3.18 3.32c-1.34 4.28-2.47 8.25-3.35 11.86-5.98 24.47-7.39 70.68-7.7 86.68-.06 3.09 2.43 5.62 5.52 5.62h48.61c8.21 0 15.67 4.78 19.1 12.24l11.9 25.88c1.98 4.32-1.18 9.25-5.93 9.25l-15.87-3.23c-7.63-1.55-15.45-1.85-23.18-.89l-5.49.69c-4.45.55-8.75 2.15-12.28 4.9-3.4 2.64-6.11 6.15-7.79 10.24-1.25 3.03-1.89 6.28-1.89 9.56 0 7.85 6.36 14.21 14.21 14.21h85.65c7.85 0 14.21-6.36 14.21-14.21v-6.3c0-9.94 1.12-19.86 3.35-29.55l4.81-20.99c1.59-6.9 7.74-11.79 14.81-11.79h24.71c7.07 0 13.22 4.89 14.81 11.79l4.81 20.99c2.23 9.69 3.35 19.61 3.35 29.55v6.3c0 7.85 6.36 14.21 14.21 14.21h85.65c7.85 0 14.21-6.36 14.21-14.21 0-3.28-.64-6.53-1.89-9.56-1.51-3.68-3.86-6.89-6.8-9.42-.33-.28-.66-.55-1-.82-3.54-2.75-7.84-4.35-12.28-4.9l-5.49-.69c-7.72-.96-15.55-.66-23.18.89l-15.87 3.23c-3.77 0-6.54-3.1-6.54-6.53 0-.9.19-1.82.6-2.72l11.9-25.88c3.43-7.46 10.89-12.24 19.1-12.24h48.61c3.09 0 5.58-2.53 5.52-5.62-.31-16-1.71-62.22-7.7-86.68-.88-3.6-2.01-7.57-3.35-11.86v-.01l3.18-3.32c22.17-23.1 40.09-49.94 52.92-79.28l4.28-9.78c1.65-3.78 2.46-7.79 2.46-11.78.01-5.8-1.71-11.58-5.08-16.53zm-344.81 80.06l-18.83-39.68c-2.47-5.2.06-11.42 5.46-13.42l12.92-4.79c-.09.59-.12 1.17-.12 1.73 0 11.57 14.19 21.99 21.53 29.27-4.02 9.18-17.43 18.22-20.96 26.89zM459 260.68l-18.83 39.68c-3.54-8.67-16.95-17.71-20.95-26.89 7.34-7.28 21.53-17.7 21.53-29.27 0-.57-.04-1.14-.12-1.73l12.92 4.79c5.39 2 7.92 8.21 5.45 13.42z"
          stroke="#FFF"
          strokeWidth="5"
          fill="none"
        />
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./animations/yomama.js